import styled from "../../styled-components.mjs";
export var Body = styled.div.withConfig({
  displayName: "Body",
  componentId: "sc-1xq0zpa-0"
})(["overflow:auto;"]);